/**
 * Spike camera: damped orbit for inspecting the test room on desktop and touch.
 * The real camera (rail + springs + handheld drift, Plan → Camera) replaces this in Greybox.
 */
import { useEffect, useMemo } from 'react'
import { OrbitControls } from 'three/addons/controls/OrbitControls.js'
import { useFrame, useThree } from '@react-three/fiber/webgpu'

export function CameraRig({ enabled }: { enabled: boolean }) {
  const camera = useThree((s) => s.camera)
  const dom = useThree((s) => s.renderer.domElement)

  const controls = useMemo(() => {
    const c = new OrbitControls(camera, dom)
    c.target.set(0, 1.7, -2)
    c.enableDamping = true
    c.dampingFactor = 0.06
    c.enablePan = false
    c.minDistance = 3
    c.maxDistance = 16
    c.minPolarAngle = Math.PI * 0.2
    c.maxPolarAngle = Math.PI * 0.52
    c.rotateSpeed = 0.5
    c.update()
    return c
  }, [camera, dom])

  useEffect(() => {
    controls.enabled = enabled
  }, [controls, enabled])

  useEffect(() => () => controls.dispose(), [controls])

  useFrame(() => {
    controls.update()
  })

  return null
}
